export const SET_UNAUTHORIZED_IMT_DATA = 'SET_UNAUTHORIZED_IMT_DATA'
export const SET_CLIENT_LAST_FILTER_IDS = 'SET_CLIENT_LAST_FILTER_IDS'

export const SET_CLIENT_TOKEN = 'SET_CLIENT_TOKEN'
export const SET_CLIENT = 'SET_CLIENT'
export const LOGOUT = 'LOGOUT'
export const SET_CLIENT_TOURS = 'SET_CLIENT_TOURS'
export const SET_PRELOADED_MENUS = 'SET_PRELOADED_MENUS'
export const SET_CHECKOUT_CLOSED = 'SET_CHECKOUT_CLOSED'
